import React from 'react'
export const skeletonAvatarPadrao = (<div className='mp-avatar-padrao-skeleton'/>)
export const skeletonAvatarCircle = (<div className='mp-avatar-circle-skeleton'/>)
